import styled from "styled-components";

export const GiftingModalStyled = styled.div`
  .box {
    width: 150px; 
    height: 150px;
    display: block;
    margin: 20px auto 10px auto;
  }

  .text {
    color: black;
    text-align: center;
    font-size: 16px;
  }
  
  .wrapper {
    width: 80%;
    display: block;
    margin: 0 auto;
  }

  .title {
    font-size: 18px;
    text-align: center;
    padding-top: 20px;
    color: black;
  }

  .message {
    text-align: center;
    font-size: 14px;
    color: black;
    padding-top: 10px;
    padding-bottom: 20px;
  }
`;